import { DateTime } from "luxon";

export function getDateFromIsoForZone(iso: string, zone: string = "UTC"): Date {
  const dt = DateTime.fromISO(iso, { zone: "utc" }).setZone(zone);
  return new Date(dt.year, dt.month - 1, dt.day);
}
